var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 20h9"}}),_c('path',{attrs:{"d":"M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }